/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog } from 'alurkerja-ui';

export const errorHandler = (err: any) => {
  if (err?.isTrialExpiredHandled) {
    return;
  }

  if (err?.response?.status === 422) {
    Dialog.error({ description: err?.response?.data.message });
  } else if (err?.code === 'ERR_NETWORK' || err?.code === undefined) {
    Dialog.error({ title: 'Network Error', description: 'Please try again later' });
  } else if (err?.response.data.message === 'ERROR LDAP') {
    Dialog.error({ title: 'Authentication Error', description: 'Please check your credentials' });
  } else if (err?.response.data.message === 'Bad Request') {
    Dialog.error({ title: 'Bad Request', description: err?.response.data.data });
  } else if (err?.response.status === 409) {
    Dialog.error({ title: 'Conflict', description: err?.response.data.error || 'Conflict occurred' });
  } else if (err?.response?.data?.error) {
    Dialog.error({ title: 'Error', description: err?.response?.data?.error });
  } else {
    Dialog.error({ title: 'Error', description: 'An unexpected error occurred. Please try again later.' });

  }
};
